import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Button from "../reusable/button"
import ContentCarousel from "@src/components/container-carousel-vertical"
import { testimonialPageData } from "@src/utils/constants/video-testimonials"
import TestimonialCard from "./testimonial-card"

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 98px;
  padding-bottom: 118px;
  @media (max-width: 1000px) {
    flex-direction: column;
    gap: 112px;
  }
  @media (max-width: 800px) {
    padding-top: 78px;
    padding-bottom: 101px;
  }
`

const Side = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: calc(50% - 75px);
  @media (max-width: 1100px) {
    width: calc(50% - 25px);
  }
  @media (max-width: 1000px) {
    width: 100%;
  }
`

const Title = styled.h2`
  color: ${props => props.theme.whiteShade};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 44px;
  letter-spacing: 0.5px;
  margin: 0;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 800px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 16px;
  }
`

const ButtonHolder = styled.span`
  width: 164px;
  @media (max-width: 800px) {
    width: 100%;
  }
`

const Image = styled.img`
  height: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
`

const MapAndTravellers = ({ map }) => {
  return (
    <Wrapper>
      <Side>
        <Title>Trip map</Title>
        <Image src={map?.image?.src} loading="lazy" />
      </Side>

      <Side>
        <Row>
          <Title>Travellers love 10Adventures</Title>
          <ButtonHolder>
            <Button to="/testimonials/" text="View all" type="yellow" />
          </ButtonHolder>
        </Row>
        <ContentCarousel
          buttonType="circle"
          buttonColor="white-gray"
          mobileSizeOnly
          icons={{
            left: "v2-arrow-small-left",
            right: "v2-arrow-small-right",
          }}
        >
          {testimonialPageData?.map((testimonial, index) => {
            return (
              <TestimonialCard
                key={`${testimonial?.name}+${index}`}
                name={testimonial?.name}
                subtitle={testimonial?.tour}
                review={testimonial?.quote}
                url={testimonial?.url}
                stars={5}
                image={encodeURI(`${testimonial.imageFolder}384x455.jpg`)}
              />
            )
          })}
        </ContentCarousel>
      </Side>
    </Wrapper>
  )
}

MapAndTravellers.propTypes = {
  map: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string,
  }),
}
export default MapAndTravellers
